export default __webpack_public_path__ + "_/images/svg_icons/app-android-4cad3b1ad895d7473205fb79e278c548f4237d02e654815114abd7c80d4c5ab8.svg";